export default __webpack_public_path__ + "6e69ec3.png";